/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, convertToRupiah, console_dev } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@sims/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Kelas';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let requet_params = 'kelas';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    const [kode, set_kode] = useState('')
    const [kelas, set_kelas] = useState('')
    const [wali_kelas, set_wali_kelas] = useState('')
    const [spp, set_spp] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_${requet_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 2){
    
            API_GET_REQUEST(`sims/master/get__________?action=search_${requet_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(file === null){
            return error('Tidak ada file')
        }

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "sims/master/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev('response uploads', response.data)
            if(response.data.result === 'success'){
                _read(pagination_active)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('sims/master/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            kode: kode,
            kelas: kelas,
            wali_kelas: wali_kelas,
            spp: spp,
		}).then((response) => {
            console_dev('response upload post', response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
                set_kode('')
                set_kelas('')
                set_wali_kelas('')
                set_spp('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>

            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>

            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div className="_lily_pad_h_d">
                                                <div className="_row _push_t_g _push_b_g">
                                                    <div className="_column">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Kode
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_kode(e.target.value)}
                                                                    value={kode}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Kelas
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_kelas(e.target.value)}
                                                                    value={kelas}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                Wali Kelas
                                                            </p>
                                                            <div className="_e_input">
                                                                <input 
                                                                    placeholder=""
                                                                    type={'text'} 
                                                                    onChange={e => set_wali_kelas(e.target.value)}
                                                                    value={wali_kelas}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                SPP
                                                            </p>
                                                            <div className="_e_input">
                                                                <div className="_row _center_align">
                                                                    <div className="_push_r_t">
                                                                        Rp.
                                                                    </div>
                                                                    <div className="_column">
                                                                        <CurrencyFormat 
                                                                            value={spp} 
                                                                            thousandSeparator={true} 
                                                                            prefix={''}
                                                                            onValueChange={(e) => {
                                                                                if(e.value.length < 10){
                                                                                    set_spp(e.value)
                                                                                }else{
                                                                                    set_spp('')
                                                                                    error('Max Length')
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                            <div className="_e_input">
                                                                <input
                                                                    className="custom-file-input" 
                                                                    type="file"
                                                                    name="file"
                                                                    placeholder=""
                                                                    onChange={_files}
                                                                />
                                                            </div>
                                                        </div> */}
                                                        <div onClick={() => {
                                                            _uploads_post(`insert_${requet_params}`)
                                                        }} className="_btn _cursor_pointer">
                                                            Simpan
                                                        </div>
                                                    </div>
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>

            {/*  DELETE AND UPDATE -------------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                _uploads_post(`delete_${requet_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Kode
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_kode(e.target.value)}
                                                        value={kode}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Kelas
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_kelas(e.target.value)}
                                                        value={kelas}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    Wali Kelas
                                                </p>
                                                <div className="_e_input">
                                                    <input 
                                                        placeholder=""
                                                        type={'text'} 
                                                        onChange={e => set_wali_kelas(e.target.value)}
                                                        value={wali_kelas}
                                                    />
                                                </div>
                                            </div>
                                            <div className="_relative _push_b_d">
                                                <p style={{color: '#888', fontSize: 13}}>
                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                    SPP
                                                </p>
                                                <div className="_e_input">
                                                    <div className="_row _center_align">
                                                        <div className="_push_r_t">
                                                            Rp.
                                                        </div>
                                                        <div className="_column">
                                                            <CurrencyFormat 
                                                                value={spp} 
                                                                thousandSeparator={true} 
                                                                prefix={''}
                                                                onValueChange={(e) => {
                                                                    if(e.value.length < 10){
                                                                        set_spp(e.value)
                                                                    }else{
                                                                        set_spp('')
                                                                        error('Max Length')
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                <div className="_e_input">
                                                    <input
                                                        className="custom-file-input" 
                                                        type="file"
                                                        name="file"
                                                        placeholder=""
                                                        onChange={_files}
                                                    />
                                                </div>
                                            </div> */}
                                            <div onClick={() => {
                                                _uploads_post(`update_${requet_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Simpan
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>                   
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {/* END DELETE AND UPDATE -------------------------------------------------------------- */}
            
            <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>

            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <tr>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Kode</th>
                            <th>Kelas</th>
                            <th>Wali Kelas</th>
                            <th>SPP</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data && data.list.length > 0 ? 
                                data.list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{decode(item.kode)}</td>
                                        <td>{decode(item.kelas)}</td>
                                        <td>{decode(item.wali_kelas)}</td>
                                        <td>{decode(convertToRupiah(item.spp))}</td>
                                        <td>
                                            <div className="_right_text _text_overflow">
                                                <div onClick={() => {
                                                    set_bamboo_delete(item.bamboo)
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Delete
                                                </div>
                                                <div onClick={() => {
                                                    set_bamboo_update(item.bamboo)
                                                    // update state -------------------------
                                                    set_test(item.kode)
                                                    set_kode(item.kode)
                                                    set_kelas(item.kelas)
                                                    set_wali_kelas(item.wali_kelas)
                                                    set_spp(item.spp)
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Update
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))

                            :
                                data &&
                                <tr>
                                    <td colSpan="10">Belum Ada Data</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/* <div className="_row _center_align">
                <div className="_column">

                </div>
                <div className="_column">
                    
                </div>
            </div> */}

            {/* <div onClick={() => {
                if(element === 'overlay'){
                    set_element(null)
                }else{
                    set_element('overlay')
                }
            }} className="_btn _cursor_pointer">
                fmc overlay btn
            </div>

            {
                element === 'overlay' ?
                    <>
                        <div className="_fmc_overlay">
                            <div className="_fmc_overlay_navbar">
                                <div className="_row _center_align">
                                    <div className="_column">
                                        <p className="_font_size_18px">Overlay</p>
                                    </div>
                                    <div onClick={() => {
                                        if(element === 'overlay'){
                                            set_element(null)
                                        }else{
                                            set_element('overlay')
                                        }
                                    }} className="_push_l_d _btn _cursor_pointer">
                                        Keluar
                                    </div>
                                </div>
                            </div>
                            <div className="_fmc_overlay_content">

                            </div>
                        </div>
                    </>
                : null
            }

            <div className="_relative">
                <div onClick={() => {
                    if(element === 'overlay_dropdown'){
                        set_element(null)
                    }else{
                        set_element('overlay_dropdown')
                    }
                }} className="_btn _cursor_pointer">
                    <div className="_row _center_align">
                        <div className="_column">
                            fmc overlay dropdown btn
                        </div>
                        <div className="_push_l_m _push_t_t">
                            {
                                element === 'overlay_dropdown' ?
                                    <ion-icon name="chevron-up-outline"></ion-icon>
                                :
                                    <ion-icon name="chevron-down-outline"></ion-icon>
                            }
                        </div>
                    </div>
                </div>
                {
                    element === 'overlay_dropdown' ?
                        // _left or _right
                        <>
                            <div className="_fmc_overlay_dropdown _left">
                                <div onClick={() => {}} className="_item">1. oke</div>
                                <div onClick={() => {}} className="_item">1. oke</div>
                                <div onClick={() => {}} className="_item">1. oke</div>
                                <div onClick={() => {}} className="_item">1. oke</div>
                            </div>
                        </>
                    : null
                }
            </div>

            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Input
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        // onChange={e => set_input(e.target.value)}
                        // value={input}
                    />
                </div>
            </div>

            <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                    
                <input
                    className="custom-file-input" 
                    type="file"
                    name="file"
                    placeholder=""
                    onChange={_files}
                />

            </div>

            <div onClick={() => {
                _uploads()
            }} className="_btn _cursor_pointer">
                Simpan
            </div>

            <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>

            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Category</th>
                        <th>
                            <div className="_right_text">
                                <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                            </div>
                        </th>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="5"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div> */}

            {/* <div style={{height: 100}}></div> */}

        </>
    );

}

export default Screen;